import { alpha, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAvatar = styled(Avatar)<{ opacity: number }>(({ theme, opacity }) => ({
  fontSize: '15px',
  backgroundColor: alpha(theme.palette.common.white, opacity),
  color: theme.palette.common.black,
}));
